"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChariotResourceFactory_1 = require("./ChariotResourceFactory");
var Errors_1 = require("../../helpers/Errors");
var memoizable_1 = require("../../helpers/memoizable");
var index_1 = require("../models/point/index");
var PointFactory = /** @class */ (function (_super) {
    __extends(PointFactory, _super);
    function PointFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointFactory.prototype.build = function (apiPoint) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, PointTypes_1, Model, entity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, PointTypes_1 = index_1.PointTypes;
                        _a.label = 1;
                    case 1:
                        if (!(_i < PointTypes_1.length)) return [3 /*break*/, 4];
                        Model = PointTypes_1[_i];
                        entity = new Model(apiPoint, this.chariot);
                        return [4 /*yield*/, entity.validate()];
                    case 2:
                        if (_a.sent()) {
                            return [2 /*return*/, entity];
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, new index_1.GenericPoint(apiPoint, this.chariot)];
                }
            });
        });
    };
    PointFactory.prototype.list = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, params, getAsAdmin, points, equipment_id_1, apiEquipment_1, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        _a = options || {}, params = _a.params, getAsAdmin = _a.getAsAdmin;
                        points = void 0;
                        if (!(params && params.equipment_id)) return [3 /*break*/, 2];
                        equipment_id_1 = params.equipment_id;
                        delete params.equipment_id;
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/atlas/equipment/".concat(equipment_id_1),
                                params: params
                            })];
                    case 1:
                        apiEquipment_1 = _b.sent();
                        if (!apiEquipment_1.points) {
                            points = [];
                        }
                        else {
                            points = apiEquipment_1.points.map(function (apiPoint) { return (__assign(__assign({}, apiPoint), { equipment_id: equipment_id_1, site_id: apiEquipment_1.site_id })); });
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.chariot.RestApi.unfurlAtlasPagination({
                            path: "/atlas/points",
                            params: __assign({ client_id: this.chariot.options.noClientBoundaries || getAsAdmin ? undefined : this.chariot.getClient()._.id }, params),
                            admin: getAsAdmin
                        })];
                    case 3:
                        points = _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, Promise.all(points.map(function (p) { return _this.build(p); }))];
                    case 5: return [2 /*return*/, _b.sent()];
                    case 6:
                        e_1 = _b.sent();
                        this.chariot.logger.catch(e_1, "Failed to list points");
                        throw e_1;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    PointFactory.prototype.iterate = function (options) {
        return __asyncGenerator(this, arguments, function iterate_1() {
            var _a, params, getAsAdmin, apiPoints, points, equipment_id, apiEquipment, _i, apiPoints_1, apiPoint, point, apiPointIterator, apiPointIterator_1, apiPointIterator_1_1, apiPoint, point, e_2_1, e_3;
            var e_2, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 25, , 26]);
                        _a = options || {}, params = _a.params, getAsAdmin = _a.getAsAdmin;
                        apiPoints = void 0;
                        points = [];
                        if (!(params && params.equipment_id)) return [3 /*break*/, 8];
                        equipment_id = params.equipment_id;
                        delete params.equipment_id;
                        return [4 /*yield*/, __await(this.chariot.RestApi.request({
                                path: "/atlas/equipment/".concat(equipment_id),
                                params: params
                            }))];
                    case 1:
                        apiEquipment = _c.sent();
                        if (!apiEquipment.points) {
                            apiPoints = [];
                        }
                        else {
                            apiPoints = apiEquipment.points;
                        }
                        _i = 0, apiPoints_1 = apiPoints;
                        _c.label = 2;
                    case 2:
                        if (!(_i < apiPoints_1.length)) return [3 /*break*/, 7];
                        apiPoint = apiPoints_1[_i];
                        return [4 /*yield*/, __await(this.build(__assign(__assign({}, apiPoint), { equipment_id: equipment_id, site_id: apiEquipment.site_id })))];
                    case 3:
                        point = _c.sent();
                        points.push(point);
                        return [4 /*yield*/, __await(point)];
                    case 4: return [4 /*yield*/, _c.sent()];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 23];
                    case 8:
                        apiPointIterator = this.chariot.RestApi.iterateAtlasPagination({
                            path: "/atlas/points",
                            params: __assign({ client_id: this.chariot.options.noClientBoundaries || getAsAdmin ? undefined : this.chariot.getClient()._.id }, params),
                            admin: getAsAdmin
                        });
                        _c.label = 9;
                    case 9:
                        _c.trys.push([9, 17, 18, 23]);
                        apiPointIterator_1 = __asyncValues(apiPointIterator);
                        _c.label = 10;
                    case 10: return [4 /*yield*/, __await(apiPointIterator_1.next())];
                    case 11:
                        if (!(apiPointIterator_1_1 = _c.sent(), !apiPointIterator_1_1.done)) return [3 /*break*/, 16];
                        apiPoint = apiPointIterator_1_1.value;
                        return [4 /*yield*/, __await(this.build(apiPoint))];
                    case 12:
                        point = _c.sent();
                        points.push(point);
                        return [4 /*yield*/, __await(point)];
                    case 13: return [4 /*yield*/, _c.sent()];
                    case 14:
                        _c.sent();
                        _c.label = 15;
                    case 15: return [3 /*break*/, 10];
                    case 16: return [3 /*break*/, 23];
                    case 17:
                        e_2_1 = _c.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 23];
                    case 18:
                        _c.trys.push([18, , 21, 22]);
                        if (!(apiPointIterator_1_1 && !apiPointIterator_1_1.done && (_b = apiPointIterator_1.return))) return [3 /*break*/, 20];
                        return [4 /*yield*/, __await(_b.call(apiPointIterator_1))];
                    case 19:
                        _c.sent();
                        _c.label = 20;
                    case 20: return [3 /*break*/, 22];
                    case 21:
                        if (e_2) throw e_2.error;
                        return [7 /*endfinally*/];
                    case 22: return [7 /*endfinally*/];
                    case 23: return [4 /*yield*/, __await(points)];
                    case 24: return [2 /*return*/, _c.sent()];
                    case 25:
                        e_3 = _c.sent();
                        this.chariot.logger.catch(e_3, "Failed to iterate points");
                        throw e_3;
                    case 26: return [2 /*return*/];
                }
            });
        });
    };
    PointFactory.prototype.get = function (pointId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/atlas/points/".concat(pointId)
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.build(response)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_4 = _a.sent();
                        this.chariot.logger.catch(e_4, "Failed to retrieve point");
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PointFactory.prototype.getLabels = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/atlas/points/labels"
                            })];
                    case 1:
                        response = (_a.sent()).results;
                        return [2 /*return*/, response];
                    case 2:
                        e_5 = _a.sent();
                        this.chariot.logger.catch(e_5, "Failed to retrieve labels for point");
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PointFactory.prototype.find = function (_a) {
        var params = _a.params, errorIfMultiple = _a.errorIfMultiple;
        return __awaiter(this, void 0, void 0, function () {
            var points, e_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chariot.Point.list({ params: params })];
                    case 1:
                        points = _b.sent();
                        if (points.length == 0) {
                            throw new Errors_1.EntityNotFoundError();
                        }
                        else if (points.length > 1 && errorIfMultiple) {
                            throw new Errors_1.MultipleMatchesError();
                        }
                        return [2 /*return*/, points[0]];
                    case 2:
                        e_6 = _b.sent();
                        this.chariot.logger.catch(e_6, "Failed to find point");
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PointFactory.prototype, "list", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], PointFactory.prototype, "iterate", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], PointFactory.prototype, "get", null);
    __decorate([
        memoizable_1.memoizable,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PointFactory.prototype, "find", null);
    return PointFactory;
}(ChariotResourceFactory_1.default));
exports.default = PointFactory;
